export default "__VITE_PUBLIC_ASSET__901064a1__"